var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAwesomeHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-history",
    "data-name": "Icon awesome-history",
    d: "M48.563,24.517A24,24,0,0,1,9.5,43.249,2.321,2.321,0,0,1,9.322,39.8l1.09-1.09A2.327,2.327,0,0,1,13.5,38.52a17.807,17.807,0,1,0-1.137-26.932L17.274,16.5a1.548,1.548,0,0,1-1.095,2.643H2.111A1.548,1.548,0,0,1,.563,17.595V3.526A1.548,1.548,0,0,1,3.206,2.432L7.984,7.209A24,24,0,0,1,48.563,24.517ZM31.055,32.141l.951-1.222A2.323,2.323,0,0,0,31.6,27.66L27.659,24.6V14.5a2.323,2.323,0,0,0-2.323-2.323H23.788A2.323,2.323,0,0,0,21.466,14.5V27.626l6.33,4.923A2.323,2.323,0,0,0,31.055,32.141Z",
    transform: "translate(0.938 0.938)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAwesomeHistory);
export default __webpack_public_path__ + "static/media/icon-awesome-history.9e836b3e4f3bbf007e0117b1b88d4467.svg";
export { ForwardRef as ReactComponent };